export default __webpack_public_path__ + "static/media/determination.6c158872.png";